/**
 * Zichtbare meldingen als kritieke HubSpot-velden ontbreken (sales kan dit in HubSpot aanvullen).
 * Backend: packages/backend/src/utils/hubspotVariablePlaceholders.ts — gelijke teksten aanhouden.
 */

const SALES_CRITICAL_TOKENS = [
  '{{company.name}}',
  '{{company.address}}',
  '{{company.zip}}',
  '{{company.city}}',
  '{{contact.firstname}}',
] as const;

const SALES_MISSING_MESSAGES: Record<(typeof SALES_CRITICAL_TOKENS)[number], string> = {
  '{{company.name}}':
    '[Niet ingevuld in HubSpot: bedrijfsnaam — vul bij de company die aan deze deal is gekoppeld]',
  '{{company.address}}':
    '[Niet ingevuld in HubSpot: adres — vul straat + huisnummer bij die company]',
  '{{company.zip}}': '[Niet ingevuld in HubSpot: postcode — company bij deal]',
  '{{company.city}}': '[Niet ingevuld in HubSpot: plaats — company bij deal]',
  '{{contact.firstname}}':
    '[Niet ingevuld in HubSpot: voornaam — primair contact op de deal]',
};

function isDraftQuoteStatus(status: string | null | undefined): boolean {
  const s = String(status || '').trim().toLowerCase();
  return !s || s === 'draft';
}

/**
 * Vult lege of ontbrekende waarden in `map` met vaste Nederlandse meldingen.
 * @param onlyIfDraft — `true`: alleen bij concept; `false`: altijd (editor).
 */
export function fillMissingHubSpotSalesPlaceholders(
  map: Record<string, string>,
  options?: { onlyIfDraft?: boolean; quoteStatus?: string | null }
): void {
  const { onlyIfDraft = false, quoteStatus } = options ?? {};
  if (onlyIfDraft && !isDraftQuoteStatus(quoteStatus)) return;

  for (const token of SALES_CRITICAL_TOKENS) {
    const raw = map[token];
    if (raw !== undefined && raw !== null && String(raw).trim() !== '') continue;
    map[token] = SALES_MISSING_MESSAGES[token];
  }
}
